import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CurrencyReferenceService extends BaseReferenceService {
  constructor() {
    super('CurrencyReference');
  }
}
